import React from 'react';
import Highcharts from 'highcharts/highstock';
import HighchartsReact from 'highcharts-react-official';
import { unitMap } from '../utils';


const HistoricalChart = ({ data, selectedStation }) => {
  // const { code, name } = selectedStation;


  const getUnit = () => {
    const unitKey = selectedStation?.code?.split('_')[1];
    return unitMap[unitKey] || '';
  };
  const series = Object.keys(data).map((key, index) => {
    const isColumnType = key.endsWith('_P');

    return {
      name: key,
      type: isColumnType ? 'column' : 'area',
      color: isColumnType ? '#086A87' : '#3366ff',
      yAxis: isColumnType ? 1 : 0,
      data: data[key].map((item) => ({
        x: item.timestamp * 1000,
        y: item.value || 0,
      })),
    };
  });

  const options = {
    chart: {
      height: 350,
      zoomType: 'x',
    },
    title: {
      text: `Station : ${selectedStation?.name}`,
    },
    xAxis: {
      type: 'datetime',
    },
    yAxis: [
      {
        title: {
          text: getUnit(data),
        },
        opposite: false,
      },
      {
        title: {
          text: getUnit(data),
        },
        opposite: true,
        gridLineWidth: 0,
        reversed: true,
      },
    ],
    tooltip: {
      shared: true,
      crosshairs: true,
    },
    plotOptions: {
      column: {
        grouping: false,
      },
    },
    rangeSelector: {
      enabled: false,
    },
    navigator: {
      enabled: true,
      height: 20,
    },
    series,
  };

  return <HighchartsReact highcharts={Highcharts} constructorType="stockChart" options={options} />;
};

export default HistoricalChart;
